module.exports = __webpack_public_path__ + "static/media/NSS2.6c8c568a.jpg";